"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_table_1 = require("react-table");
const react_use_1 = require("react-use");
const EmptyDataRow_1 = require("./Elements/EmptyDataRow");
const ReactTableHeader_1 = __importDefault(require("./Elements/ReactTableHeader"));
const ReactTableRow_1 = __importDefault(require("./Elements/ReactTableRow"));
const Style_1 = require("./Style");
const ReactTableContext_1 = require("./utility/ReactTableContext");
const useRowSpan_1 = __importStar(require("./utility/useRowSpan"));
const styles = {
    table: (enableVirtualScroll, enableColumnsVirtualScroll) => {
        const style = { tableLayout: 'auto' };
        if (enableVirtualScroll) {
            style.position = 'sticky';
            style.top = 0;
        }
        if (enableColumnsVirtualScroll) {
            style.position = 'sticky';
            style.left = 0;
        }
        return style;
    },
};
const counterStyle = {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    pointerEvents: 'none',
    textAlign: 'center',
    fontWeight: 'bolder',
    color: 'white',
    fontSize: '1.4em',
};
const ReactTableInner = (0, react_1.forwardRef)(function ReactTableInner(props, ref) {
    const { data, columns, highlightedSource, contextMenu = [], onContextMenuSelect, onScroll, approxItemHeight = 40, enableVirtualScroll = false, enableColumnsVirtualScroll = false, approxColumnWidth = 40, groupKey, onClick, activeRow, totalCount, indexKey = 'index', onSortEnd, rowStyle, disableDefaultRowStyle = false, enableDefaultActiveRow = false, emptyDataRowText = 'No Data', } = props;
    const isSortedEventTriggered = (0, react_1.useRef)(false);
    const virtualBoundary = (0, ReactTableContext_1.useReactTableContext)();
    const [rowIndex, setRowIndex] = (0, react_1.useState)();
    const timeoutIdRef = (0, react_1.useRef)();
    const [isCounterVisible, setCounterVisibility] = (0, react_1.useState)(false);
    const memoColumns = (0, react_1.useMemo)(() => {
        const end = virtualBoundary.columns.end === columns.length - 1
            ? virtualBoundary.columns.end + 1
            : virtualBoundary.columns.end;
        return enableColumnsVirtualScroll
            ? columns.slice(virtualBoundary.columns.start, end)
            : columns;
    }, [enableColumnsVirtualScroll, virtualBoundary.columns, columns]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, rowSpanHeaders, } = (0, react_table_1.useTable)({
        columns: memoColumns,
        data,
        autoResetSortBy: false,
    }, react_table_1.useSortBy, useRowSpan_1.default);
    function clickHandler(event, row) {
        setRowIndex(row.index);
        onClick?.(event, row);
    }
    function scrollHandler(e) {
        if (enableVirtualScroll) {
            onScroll(e);
        }
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
            setCounterVisibility(true);
        }
        timeoutIdRef.current = setTimeout(() => {
            setCounterVisibility(false);
        }, 1000);
    }
    (0, react_1.useEffect)(() => {
        if (isSortedEventTriggered.current) {
            const data = rows.map((row) => row.original);
            onSortEnd?.(data);
            isSortedEventTriggered.current = false;
        }
    }, [onSortEnd, rows]);
    function headerClickHandler() {
        isSortedEventTriggered.current = true;
    }
    const end = virtualBoundary.rows.end === rows.length - 1
        ? virtualBoundary.rows.end + 1
        : virtualBoundary.rows.end;
    const rowsData = enableVirtualScroll
        ? rows.slice(virtualBoundary.rows.start, end)
        : rows;
    const index = rowsData.at(-1)?.original[indexKey] || rowsData.at(-1)?.index;
    const total = totalCount ? totalCount : data.length;
    const startColumn = columns[virtualBoundary.columns.start].Header;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { ref: ref, className: "table-container", style: {
                    overflowY: 'auto',
                    ...(enableColumnsVirtualScroll && { overflowX: 'auto' }),
                    position: 'relative',
                    height: '100%',
                }, onScroll: scrollHandler, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                            height: enableVirtualScroll
                                ? approxItemHeight * (data.length + 1)
                                : '100%',
                            position: 'absolute',
                            width: enableColumnsVirtualScroll
                                ? approxColumnWidth * (columns.length + 1)
                                : '100%',
                            pointerEvents: 'none',
                        } }), (0, jsx_runtime_1.jsxs)("table", { ...getTableProps(), css: Style_1.ReactTableStyle, style: styles.table(enableVirtualScroll, enableColumnsVirtualScroll), children: [(0, jsx_runtime_1.jsx)(ReactTableHeader_1.default, { headerGroups: headerGroups, onClick: headerClickHandler }), (0, jsx_runtime_1.jsxs)("tbody", { ...getTableBodyProps(), children: [!data ||
                                        (data?.length === 0 && ((0, jsx_runtime_1.jsx)(EmptyDataRow_1.EmptyDataRow, { columns: columns, text: emptyDataRowText }))), rowsData.map((row, index) => {
                                        prepareRow(row);
                                        (0, useRowSpan_1.prepareRowSpan)(rows, enableVirtualScroll
                                            ? index + virtualBoundary.rows.start
                                            : index, rowSpanHeaders, groupKey);
                                        const { key, ...restRowProps } = row.getRowProps();
                                        return ((0, jsx_runtime_1.jsx)(ReactTableRow_1.default, { ...restRowProps, row: row, contextMenu: contextMenu, onContextMenuSelect: onContextMenuSelect, onClick: !activeRow && enableDefaultActiveRow
                                                ? clickHandler
                                                : onClick, highlightedSource: highlightedSource, isRowActive: !activeRow
                                                ? enableDefaultActiveRow
                                                    ? rowIndex === index
                                                    : false
                                                : activeRow(row), rowStyle: typeof rowStyle === 'function' ? rowStyle(row) : rowStyle, disableDefaultRowStyle: disableDefaultRowStyle }, key));
                                    })] })] })] }), (enableVirtualScroll || enableColumnsVirtualScroll) && ((0, jsx_runtime_1.jsxs)("p", { style: {
                    ...counterStyle,
                    ...(enableColumnsVirtualScroll && { bottom: '15px' }),
                    opacity: !isCounterVisible ? '0' : '1',
                    transition: 'all 0.5s',
                    visibility: !isCounterVisible ? 'hidden' : 'visible',
                }, children: [enableColumnsVirtualScroll && typeof startColumn === 'string' && ((0, jsx_runtime_1.jsxs)("span", { style: { left: 0 }, children: [`Column ${startColumn}`, " "] })), typeof index === 'number' ? index + 1 : total, " / ", total] }))] }));
});
function ReactTable(props) {
    const { data, approxItemHeight = 40, approxColumnWidth = 40, groupKey, onSortEnd, columns, style = {}, } = props;
    const containerRef = (0, react_1.useRef)(null);
    const visibleRowsCountRef = (0, react_1.useRef)(0);
    const visibleColumnsCountRef = (0, react_1.useRef)(0);
    const [mRef, { height, width }] = (0, react_use_1.useMeasure)();
    const [tableVirtualBoundary, setTableVirtualBoundary] = (0, react_1.useState)({
        rows: {
            start: 1,
            end: 0,
        },
        columns: {
            start: 1,
            end: 0,
        },
    });
    (0, react_1.useLayoutEffect)(() => {
        if (containerRef.current && height && width) {
            const header = containerRef.current.querySelectorAll('thead');
            const rowsCount = Math.ceil((Math.ceil(height) - Math.ceil(header[0].clientHeight)) /
                approxItemHeight);
            const columnsCount = Math.ceil(Math.ceil(width) / approxColumnWidth);
            if ((rowsCount > 0 && rowsCount !== visibleRowsCountRef.current) ||
                (columnsCount > 0 && columnsCount !== visibleColumnsCountRef.current)) {
                visibleRowsCountRef.current = rowsCount;
                visibleColumnsCountRef.current = columnsCount;
                setTableVirtualBoundary({
                    rows: { start: 0, end: rowsCount },
                    columns: { start: 0, end: columnsCount },
                });
            }
        }
    }, [approxColumnWidth, approxItemHeight, height, width]);
    function lookForGroupIndex(currentIndex, side) {
        const currentItem = data[currentIndex];
        if (currentItem?.index && groupKey) {
            switch (side) {
                case -1: {
                    let index = currentIndex - 1;
                    while (index > 0) {
                        if (data[index][groupKey] !== currentItem[groupKey]) {
                            return index + 1;
                        }
                        index--;
                    }
                    return currentIndex;
                }
                case 1: {
                    let index = currentIndex + 1;
                    while (index < data.length) {
                        if (data[index][groupKey] !== currentItem[groupKey]) {
                            return index - 1;
                        }
                        index++;
                    }
                    return currentIndex;
                }
                default:
                    return currentIndex;
            }
        }
        return currentIndex;
    }
    function findColumnStartIndex(index, numberOfVisibleColumns) {
        const newIndex = index - numberOfVisibleColumns;
        return newIndex >= columns.length ? newIndex : index;
    }
    function findColumnEndIndex(index, numberOfVisibleColumns) {
        const newIndex = index + numberOfVisibleColumns;
        return newIndex >= columns.length ? columns.length - 1 : newIndex;
    }
    function findStartIndex(index, numberOfVisibleRows) {
        const newIndex = index - numberOfVisibleRows;
        const currentIndx = newIndex >= data.length ? newIndex : index;
        // return currentIndx;
        // Look for the first index of the group
        return lookForGroupIndex(currentIndx, -1);
    }
    function findEndIndex(index, numberOfVisibleRows) {
        const newIndex = index + numberOfVisibleRows;
        const currentIndx = newIndex >= data.length ? data.length - 1 : newIndex;
        // return currentIndx;
        // Look for the last index of the group
        return lookForGroupIndex(currentIndx, 1);
    }
    function scrollHandler() {
        if (containerRef.current) {
            const { scrollTop, scrollLeft } = containerRef.current;
            const rowCurrentIndx = Math.ceil(scrollTop / approxItemHeight);
            const rowStart = findStartIndex(rowCurrentIndx, visibleRowsCountRef.current);
            const rowEnd = findEndIndex(rowCurrentIndx, visibleRowsCountRef.current);
            const columnCurrentIndx = Math.ceil(scrollLeft / approxColumnWidth);
            const columnStart = findColumnStartIndex(columnCurrentIndx, visibleColumnsCountRef.current);
            const columnEnd = findColumnEndIndex(columnCurrentIndx, visibleColumnsCountRef.current);
            setTableVirtualBoundary({
                rows: { start: rowStart, end: rowEnd },
                columns: { start: columnStart, end: columnEnd },
            });
        }
    }
    return ((0, jsx_runtime_1.jsx)(ReactTableContext_1.ReactTableProvider, { value: tableVirtualBoundary, children: (0, jsx_runtime_1.jsx)("div", { ref: mRef, style: {
                position: 'relative',
                height: '100%',
            }, css: style, children: (0, jsx_runtime_1.jsx)(ReactTableInner, { onScroll: scrollHandler, onSortEnd: onSortEnd, ref: containerRef, ...props }) }) }));
}
exports.default = (0, react_1.memo)(ReactTable);
